import {
    SmallTextHelper
} from '../PrismicHelpers';

export const newsPageHelper = (response) => {
    const newsData = response.result;
    let newsObject = newsData.map(news => {
        return {
            uid: SmallTextHelper(news.id),
            news_title: SmallTextHelper(news.data.news_page_title),
            news_summary: SmallTextHelper(news.data.news_summary),
        }
    })
    return newsObject;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/NewsHelper.js